namespace $ { $mol_style_attach( "mol/spell/demo/demo.view.css",
 "[mol_spell_demo_report] {\n\tcolor: var(--mol_theme_focus);\n}\n"
) }